<video id="{{rid}}" class="" src="{{preview_url}}?t={{rid}}" poster="{{thumbnail_url}}" controls preload="none"></video>
